import request from '@/utils/request'
//查询助教信息
export function index(data) {
    return request({
        url: '/api/tutor/index',
        method: 'POST',
        data: data || {}
    })
}
//保存助教填写信息
export function edit(data) {
    return request({
        url: '/api/tutor/edit',
        method: 'POST',
        data: data || {}
    })
}
//保存图片
export function save_tutor_qrcode(data) {
    return request({
        url: '/api/tutor/save_tutor_qrcode',
        method: 'POST',
        data: data || {}
    })
}

// 助教期次列表
export function TutorList(data) {
    return request({
        url: '/api/Tutor/TutorList',
        method: 'POST',
        data: data || {}
    })
}
// 助教学员信息
export function TutorGroupList(data) {
    return request({
        url: '/api/Tutor/TutorGroupList',
        method: 'POST',
        data: data || {}
    })
}
// 助教项目列表
export function projectList(data) {
    return request({
        url: '/api/Tutor/projectList',
        method: 'POST',
        data: data || {}
    })
}

// 助教用户作业（报告）
export function getWork(data) {
    return request({
        url: '/api/Tutor/getWork',
        method: 'POST',
        data: data || {}
    })
}
// 保存助教用户作业（报告）
export function setWork(data) {
    return request({
        url: '/api/Tutor/setWork',
        method: 'POST',
        data: data || {}
    })
}
// 助教项目详情
export function projectdetail(data) {
    return request({
        url: '/api/Tutor/projectdetail',
        method: 'POST',
        data: data || {}
    })
}
// 助教个人详细信息
export function getTutorInfo(data) {
    return request({
        url: 'api/tutor/getTutorInfo',
        method: 'POST',
        data: data || {}
    })
}
// 邀请老助教
export function inviteDo(data) {
    return request({
        url: 'api/tutor/inviteDo',
        method: 'POST',
        data: data || {}
    })
}